(function (window, $) {
  'use strict';

  function imageUrl(image) {
    var source = typeof image === 'string' ? image : image.src;
    var url = new URL(source, window.location.href);
    url.searchParams.set('width', '600');
    url.searchParams.set('height', '600');
    url.searchParams.set('crop', 'center');
    return url.href;
  }

  function createSlide(image, index, product, showNewBadge) {
    var slide = document.createElement('div');
    slide.className = 'product-slider_nav-item position-relative';

    var photo = document.createElement('img');
    photo.className = 'img-fluid mx-auto';
    photo.src = imageUrl(image);
    photo.alt = (typeof image === 'object' && image.alt) || product.title;
    photo.width = 600;
    photo.height = 600;
    photo.loading = index === 0 ? 'eager' : 'lazy';
    if (index === 0) photo.setAttribute('fetchpriority', 'high');
    slide.appendChild(photo);

    if (index === 0 && showNewBadge && (product.tags || []).indexOf('NEW') !== -1) {
      var badge = document.createElement('span');
      badge.className = 'new-tag';
      badge.textContent = 'NEW';
      slide.appendChild(badge);
    }

    return slide;
  }

  window.KnickerProductGallery = {
    sync: function (root, product) {
      var gallery = root.querySelector('.product-slider_mob');
      if (!gallery || !product) return;

      var slider = $(gallery);
      if (gallery.getAttribute('data-product-id') !== String(product.id)) {
        // Slick owns these children: remove its wrappers and clones before replacing them.
        if (slider.hasClass('slick-initialized')) slider.slick('unslick');
        slider.empty();

        var images = product.images || [];
        if (!images.length && product.featured_image) images = [product.featured_image];
        var showNewBadge = gallery.getAttribute('data-show-new-badge') === 'true';
        images.forEach(function (image, index) {
          gallery.appendChild(createSlide(image, index, product, showNewBadge));
        });
        gallery.setAttribute('data-product-id', String(product.id));
      }

      // A size change within the same colour leaves the customer's current slide intact.
      if (!slider.hasClass('slick-initialized') && gallery.children.length) {
        slider.slick({
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: true,
          focusOnSelect: true
        });
      }
    }
  };
})(window, jQuery);
